
import Vue, { PropType } from 'vue';
import IconButton from '@/common/icon-button/IconButton.vue';
import { get } from 'lodash';
import Api from '@/core/api';

interface InterprefyConfig {
    iframeUrl: string
}

export default Vue.extend({
    components: {
        IconButton
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        config: {
            type: Object as PropType<InterprefyConfig>,
            default: () => ({} as InterprefyConfig)
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    data() {
        return {
            createIframe: false,
            showIframe: false
        };
    },

    computed: {
        iframeUrl(): string | undefined {
            return this.config?.iframeUrl;
        }
    },

    methods: {
        onClick(): void {
            this.createIframe = true;
            this.showIframe = !this.showIframe;
            if (this.showIframe) {
                this.api.mute();
            }
            this.api.alwaysShowControlBar(this.showIframe);
        }
    }
});
